import axiosHelper from '../utils/axios';

export default (() => {
  const accessPath = '/access';

	let activeNotificationsPromise;
	let activeNotificationsCache;

  async function getActiveNotifications() {
		if (activeNotificationsCache) {
			return activeNotificationsCache;
		}
		if (activeNotificationsPromise) {
			return activeNotificationsPromise;
		}

		activeNotificationsPromise = axiosHelper
			.getAccess('hideLoadingIndicator')
			.get(`${accessPath}/notifications`)
			.then(r => {
				activeNotificationsCache = r.data;
				return activeNotificationsCache;
			})
			.catch(err => {
				activeNotificationsPromise = null;
				throw err;
			});

		return activeNotificationsPromise;
  }

  return {
    getActiveNotifications,
  };
})();
